import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { ApiMethod } from '../decorators/api-method.decorator';
import { Observable, of } from 'rxjs';
import { DocumentThread, NotifyUser } from '../models/document-thread.model';
import { Item } from '../models/item.model';

@Injectable({
	providedIn: 'root'
})
export class DocumentThreadService {

	private readonly baseUrl = `${environment.baseUrl}/thread-document`;
	constructor(
		private http: HttpClient,
		private authService: AuthService
	) { }

	@ApiMethod()
	public getDocumentThreads(documentId: number): Observable<DocumentThread[]> {
		return this.http.get<DocumentThread[]>(`${this.baseUrl}/documents/${documentId}`, { headers: this.authService.getAuthenticationHeader() });
	}

	@ApiMethod()
	public addDocumentThread(documentThread: DocumentThread): Observable<DocumentThread> {
		return this.http.post<DocumentThread>(`${this.baseUrl}`, documentThread, { headers: this.authService.getAuthenticationHeader() });
	}

	@ApiMethod()
	public updateDocumentThread(documentThread: DocumentThread): Observable<DocumentThread> {
		return this.http.put<DocumentThread>(`${this.baseUrl}/${documentThread.id}`, documentThread, { headers: this.authService.getAuthenticationHeader() });
	}

	@ApiMethod()
	public getNotifyUsers(token: string, jobDocumentId: number): Observable<NotifyUser[]> {
		return this.http.get<NotifyUser[]>(`${this.baseUrl}/${token}/notify-users/job-document/${jobDocumentId}`);
	}

	@ApiMethod()
	public completeDocumentThread(documentThread: DocumentThread): Observable<DocumentThread> {
		return this.http.put<DocumentThread>(`${this.baseUrl}/complete/${documentThread.id}`, documentThread, { headers: this.authService.getAuthenticationHeader() });
	}

	@ApiMethod()
	public getDocumentThreadTypes(): Observable<Item<number, string>[]> {
		return this.http.get<Item<number, string>[]>(`${this.baseUrl}/thread-types`, { headers: this.authService.getAuthenticationHeader() });
	}
}
